<template>
  <div class="no-media-access">
    <h3>{{ c('no_media_access.title') }}</h3>
    <p>{{ c('no_media_access.paragraph_1') }}</p>
    <p>{{ c('no_media_access.paragraph_2') }}</p>
    <ul class="no-media-access__browser-instructions">
      <li
        v-for="[browser, url] of [
          [
            'Chrome',
            'https://support.google.com/chrome/answer/2693767?hl=en-GB&co=GENIE.Platform%3DAndroid',
          ],
          [
            'Firefox',
            'https://support.mozilla.org/en-US/kb/how-manage-your-camera-and-microphone-permissions',
          ],
          ['Safari', 'https://support.apple.com/en-za/guide/safari/ibrwe2159f50/mac'],
        ]"
        :key="url"
      >
        <a :href="url" target="_blank">{{ browser }}</a>
      </li>
    </ul>
    <button class="attest-button attest-button--ternary" @click="() => $emit('retry')">
      {{ c('no_media_access.retry') }}
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { c } from '../../../intl'

export default defineComponent({
  emits: {
    retry: () => true,
  },
  setup() {
    return {
      c,
    }
  },
})
</script>

<style lang="postcss">
.no-media-access {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  text-align: left;

  &__browser-instructions {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    list-style: none;
    margin: 0;
    padding: 0;
  }
}
</style>
